<template>
  <ca-field label="Turno da jornada">
    <ca-search-select
      v-model="variableShift"
      :on-query-term-change="onQueryTermChanged"
      :on-query="onQuery"
      :on-query-success="onQuerySuccess"
      :on-open="onOpen"
      required
      :on-change="refreshForm">
      <ca-option
        v-for="shift in workShifts.content"
        :key="shift.id"
        :value="shift.id">
        {{ shift.code }}
      </ca-option>
    </ca-search-select>
  </ca-field>
</template>

<script>
import { getWorkShifts } from 'accountant/employer/work-shifts/workShiftService';

export default {
  name: 'VariableShiftSelect',
  props: {
    value: [Number, String],
    refreshForm: Function,
  },
  data() {
    return {
      workShifts: {},
      searchTerm: '',
      variableShift: this.value,
      selectedVariableShift: null,
    };
  },
  watch: {
    variableShift(value) {
      this.$emit('input', value);
      this.$emit('change');
    },
  },
  created() {
    if (this.variableShift) {
      this.onQuery()
        .then(this.onQuerySuccess)
        .then(this.setSelectedVariableShift);
    }
  },
  methods: {
    onOpen() {
      this.$emit('on-open');
    },
    onQueryTermChanged(value) {
      this.searchTerm = value;
    },
    onQuery() {
      return getWorkShifts({ search: this.searchTerm, pageSize: null });
    },
    onQuerySuccess(response) {
      this.workShifts = response.content ? response : { content: response };
    },
    setSelectedVariableShift() {
      this.$set(this, 'selectedVariableShift', {
        value: this.variableShift,
        label: this.variableShift,
      });
    },
  },
};
</script>
